module.exports = __webpack_public_path__ + "static/media/bbva-100px.e1dec6f8.svg";